"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Pension["default"];
  }
});
var _Pension = _interopRequireDefault(require("./Pension"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }